import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAdminAuth } from '@/features/admin';
import { FullPageSpinner } from '@/shared/ui/Spinner';

import { routes } from './route-paths';

export function AdminRoute() {
  const { status } = useAdminAuth();
  const location = useLocation();

  if (status === 'checking') return <FullPageSpinner />;
  if (status !== 'authenticated') {
    return <Navigate to={routes.admin.login} replace state={{ from: location }} />;
  }
  return <Outlet />;
}
